import type {
    ChildrenComponentProps,
    ComponentEventHandler,
} from '@fluentui/react-northstar';
import type { ButtonProps } from '@archipro-design/aria';
import { useAppDisplayModeContext } from '@archipro-design/aria';
import FilterContainerDesktop from '~/modules/search/components/filter-drawer/FilterContainer.desktop';
import FilterContainerMobile from '~/modules/search/components/filter-drawer/FilterContainer.mobile';
import type { SearchIndex } from '~/modules/search';
import type { FilterSortByProps } from './FilterSortBy.mobile';

export interface FilterContainerProps
    extends ChildrenComponentProps,
        FilterSortByProps {
    /** primary bottom button */
    primaryButton?: ButtonProps;
    /** secondary bottom button */
    secondaryButton?: ButtonProps;
    /** called after the close button is clicked */
    onClose?: ComponentEventHandler<never>;
    /** disable ListForm */
    disabled?: boolean;
    category?: SearchIndex;
    open?: boolean;
    hideCloseButton?: boolean;
}

const FilterContainer = (props: FilterContainerProps) => {
    const { desktop } = useAppDisplayModeContext();

    return desktop ? (
        <FilterContainerDesktop {...props} />
    ) : (
        <FilterContainerMobile {...props} />
    );
};

export default FilterContainer;
